module.exports = __webpack_public_path__ + "static/man-me2-995fe6ceb9953e9e1587a1ec0d94d799.jpg";